import { computed, Context, createStore, ExtendedModel, idProp, model, Model, override, prop } from '@weavix/mobx';
import { myUserId } from '../my-profile-store/my-profile-store';
import { userRef } from '../users-store/users-store';
import { channelsContext } from 'models-mobx/channels-store/channels-store';

export const getPerson = (accountId: string, personId = myUserId()) => {
    return peopleContext.get().get(getFullId(accountId, personId));
};

const ADC_FIELDS = new Set([
    'crafts',
    'group',
    'tags',
]);

@model('Person')
export class Person extends Model({
    id: idProp, // === userId, identical for same person on different accounts
    userId: prop<string>(), // same as ID if person is still on the account. otherwise blank
    accountId: prop<string>(),
    personId: prop<string>(),
    crafts: prop<string[]>(),
    group: prop<string>(),
    tags: prop<string[]>(),
    properties: prop<Array<{ key: string, value: string }>>(),
    folderId: prop<string>(),
}) {
    constructor(...args) {
        super(...args);
        this.id = args[0].personId; // id from sync service is accountId-personId
    }

    update(arg) {
        this.user?.invalidateChannelUserCache(this.accountId ? [this.accountId] : undefined);
        super.update({ ...arg, id: arg.personId || this.id });
    }

    @computed
    get user() {
        if (!this.userId) return;
        return userRef(this.id).maybeCurrent;
    }

    get hasUser() {
        return this.user?.accountIds.includes(this.accountId);
    }

    get companyId() {
        return this.user.companyId;
    }
}

const base = createStore<Person>('people', Person);

export const peopleContext = base.context as Context<PeopleStore>;
export const personRef = base.ref;

export const accountPersonRef = (accountId: string, personId: string) => {
    return personRef(getFullId(accountId, personId));
};

const getFullId = (accountId: string, id: string) => `${accountId}-${id}`;

@model('PeopleStore')
export class PeopleStore extends ExtendedModel(base.Store, {
}) {
    getPerson(personId: string, accountId: string, person?: Person) {
        const id = getFullId(accountId, personId);
        return this.get(id, person);
    }

    @override
    updateValue(value: any, keys?: any) {
        super.updateValue(value, keys);
        const hasAdcField = keys ? (keys as any[]).some(key => ADC_FIELDS.has(key)) : true;
        if (hasAdcField && value.accountId) {
            const adcChannels = channelsContext.getDefault().channels?.filter(x => x.accountId === value.accountId);
            adcChannels?.forEach(channel => {
                channel.clearUserCache();
            });
        }
    }
}
